import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import RolePrivilegesFields from './RolePrivilegesFields'

export const RolePrivilegesEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar {...props} />}>
      <Grid container spacing={8}>
        <RolePrivilegesFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default RolePrivilegesEdit
